/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WorkingStatus = {
    Remote: 'REMOTE',
    Hybrid: 'HYBRID',
    OnSite: 'ON_SITE'
} as const;
export type WorkingStatus = typeof WorkingStatus[keyof typeof WorkingStatus];


export function instanceOfWorkingStatus(value: any): boolean {
    for (const key in WorkingStatus) {
        if (Object.prototype.hasOwnProperty.call(WorkingStatus, key)) {
            // @ts-ignore
            if (WorkingStatus[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function WorkingStatusFromJSON(json: any): WorkingStatus {
    return WorkingStatusFromJSONTyped(json, false);
}

export function WorkingStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkingStatus {
    return json as WorkingStatus;
}

export function WorkingStatusToJSON(value?: WorkingStatus | null): any {
    return value as any;
}

